import React from 'react';
import { useSelector } from 'react-redux';
import Widget from '../base/Widget.jsx';
import RGL, { WidthProvider } from 'react-grid-layout';
import styles from './TabContainerWidget.module.scss';
import NoDataComponent from '../../no_data_component.jsx';
import { useTabContainer } from '../../hooks/useTabContainer.js';
import titleFontSize from '../base/titleFontSize.js';

const ReactGridLayout = WidthProvider(RGL);

const TabContainerWidget = ({ widgetId, editing, editable }) => {
  const tabs = useSelector((state) => state.dashboard.widgets[widgetId].settings?.tabs || []);
  const title = useSelector((state) => state.dashboard.widgets[widgetId].theme?.overrides?.common?.title) || {};
  const renderFontSize = titleFontSize(title.fontSize);

  const { onDrop, activeWidget, layout, isEditing, activeTab, setActiveTab } = useTabContainer({ widgetId });

  if (!tabs.length) return <NoDataComponent />;

  return (
    <div className={styles['tab-container-widget']} style={{ display: 'flex', flexDirection: 'column', height: '100%', position: 'relative' }}>
      <div className={styles['tab-header']}>
        {tabs.map((t, i) => (
          <div key={`tab-${t.id}`} className='text-truncate pull-left'>
            <h4
              className={`text-truncate cursor-pointer ${activeTab === t.id ? styles['border-bottom'] : ''}`}
              style={{ fontSize: renderFontSize }}
              onClick={() => setActiveTab(t.id)}
            >
              {t.name || I18n.t('unnamed')}
            </h4>
          </div>
        ))}
      </div>

      {activeWidget && <div className={`widget-grid-item ${isEditing ? 'selected-widget': ''}`}>
          <Widget widgetId={activeWidget.id} editable={editable} isEditing={isEditing} />
      </div>}

      {!activeWidget && <>
        <ReactGridLayout
          style={{
            height: '100%',
            overflow: 'hidden',
            border: '1px solid #ececec',
            borderRadius: 2
          }}
          layout={layout}
          cols={1}
          rowHeight={Infinity}
          isDroppable
          onDrop={onDrop}
          className={styles['react-grid-layout']}
          isDraggable={false}
          isResizable={false}
        >
        </ReactGridLayout>
        <p className='description'>{I18n.t('drag_new_component_here')}</p>
      </>}
    </div>
  );
};

export default TabContainerWidget;
